import { Fragment, useState } from "react";
import HexCard from "../../../../components/HexCard";
import SmartImage from "../../../../components/SmartImage";
import PricePerVolumeText from "../../../../components/PricePerVolumeText";
import { getStyle } from "../../../../hooks/use-styles";
import {
  calculateDiscount,
  formatCurrency,
} from "../../../../utils/common-utils";

import ProductDetailModal from "../../ProductDetailModal";

import "./style.css";

import DiscountFreeBadge from "./DiscountFreeBadge";
import DistanceBadge from "./DistanceBadge";
import { pKG_VOLUME } from "../../../../utils/constants";

const ProductCardItem = (props) => {
  const { product, material, containerOption, showDistance } = props;
  const { imageUrls, amount, originalAmount, name, distanceToLocationMeters } =
    product;

  const { value: originalValue } = originalAmount;
  const { value, currency } = amount;

  const [detailModal, setDetailModal] = useState(false);

  const toggleModal = () => {
    setDetailModal((prev) => !prev);
  };

  const discount =
    value !== originalValue
      ? calculateDiscount(value, originalValue, currency)
      : -1;

  const hasDiscount = discount > 0;

  const formattedDiscount = hasDiscount ? +discount.replaceAll(".00", "") : 0;
  const isFree = formattedDiscount === 100 || originalValue === 0;

  return (
    <Fragment>
      {detailModal && (
        <ProductDetailModal
          productId={product.id}
          material={material}
          onClose={toggleModal}
        />
      )}

      <HexCard className="product-card-item pointer" onClick={toggleModal}>
        <div className="product-item-image relative">
          <SmartImage
            src={imageUrls?.[0] ? `${imageUrls[0]}?size=lg` : null}
            alt={name}
            fit="contain"
            className="product-card-image"
          />

          <DiscountFreeBadge discount={discount} isFree={isFree} />
          {showDistance && (
            <DistanceBadge distance={distanceToLocationMeters} />
          )}
        </div>

        <div className="product-item-content">
          <div className="product-card-title">
            <div className="product-name ellipse-text-ww">{name}</div>
          </div>

          <div className="product-price-details flex align-center">
            <PricePerVolumeText
              price={hasDiscount ? value : originalAmount.value}
              currency={originalAmount.currency}
              volume={pKG_VOLUME}
              showVolume={containerOption.variableVolume}
            />

            {hasDiscount && (
              <span
                className="promoted-original-amount strike-through"
                style={{ color: getStyle("primaryPink") }}
              >
                {formatCurrency(originalValue, currency)}
              </span>
            )}
          </div>
        </div>
      </HexCard>
    </Fragment>
  );
};

export default ProductCardItem;
